import { CONSTANTS } from '../../../constants/constants';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { useTheme } from '@mui/material/styles';
import ReactApexChart from 'react-apexcharts';

function NRSummaryDonut({ low = 0, medium = 0, high = 0, critical = 0, dataPointSelection, isPrintView = false }) {
  const theme = useTheme();
  const series = [low, medium, high, critical];

  const options = {
    chart: {
      type: 'donut',
      animations: {
        enabled: !isPrintView
      },
      events: {
        ...{ dataPointSelection: dataPointSelection },
        dataPointMouseEnter: event => {
          if (event && !!event.currentTarget) event.currentTarget.style.cursor = 'pointer';
        }
      }
    },
    colors: theme.palette.severityPalette.slice(2).map(item => item.main),
    dataLabels: {
      enabled: false
    },
    fill: {
      type: 'solid'
    },
    labels: [
      capitalizeFirstLetter(CONSTANTS.SEVERITIES.LOW),
      capitalizeFirstLetter(CONSTANTS.SEVERITIES.MEDIUM),
      capitalizeFirstLetter(CONSTANTS.SEVERITIES.HIGH),
      capitalizeFirstLetter(CONSTANTS.SEVERITIES.CRITICAL)
    ],
    legend: {
      ...theme.typography.body2,
      labels: {
        colors: theme.palette.text.primary
      },
      show: true,
      formatter: function (val, opts) {
        return val + ' - ' + opts.w.globals.series[opts.seriesIndex];
      },
      horizontalAlign: 'left',
      markers: {
        offsetX: -5
      },
      offsetY: 40
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        expandOnClick: false,
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 15,
              formatter: function (val) {
                return val;
              }
            },
            value: {
              show: true,
              color: theme.palette.text.primary,
              ...theme.typography.h3,
              offsetY: -25,
              formatter: function (val) {
                return val;
              }
            },
            total: {
              show: true,
              showAlways: true,
              label: CONSTANTS.SUMMARY.VULNERABILITIES,
              ...theme.typography.body2,
              color: theme.palette.text.secondary,
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((acc, cv) => acc + cv, 0);
              }
            }
          }
        }
      }
    },
    states: {
      hover: {
        filter: {
          type: 'none'
        }
      }
    },
    stroke: {
      colors: [theme.palette.background.paper]
    },
    title: {
      text: CONSTANTS.SUMMARY.SEVERITY_COUNT,
      align: 'left',
      marginBottom: 10,
      offsetX: 225,
      offsetY: 30,
      floating: true,
      style: {
        ...theme.typography.label,
        color: theme.palette.text.secondary
      }
    },
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      onDatasetHover: {
        highlightDataSeries: false
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }
    ]
  };

  return (
    <div>
      <div id="chart-summary-container">
        <ReactApexChart
          key={'summary-chart-donut'}
          id={'summary-chart-donut-id'}
          options={options}
          series={series}
          type="donut"
          width={390}
          height={390}
        />
      </div>
    </div>
  );
}

export default NRSummaryDonut;
